// var config = require('../../config');
import React from 'react';
import { Client } from '../../Client';
import { Tabbordion, TabPanel, TabLabel, TabContent } from 'react-tabbordion'
import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import vfsFonts from 'pdfmake/build/vfs_fonts'

import './Passport.css'
const uuidv4 = require('uuid/v4');

import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css';


const findIndex = (value, arr, prop) => {
    for (var i = 0; i < arr.length; i++) {
        if(arr[i][prop] === value) {
            return i;
        }
    }
    return -1; //to handle the case where the value doesn't exist
}


/*
 * Gets 'title' of item lists and splits into two arrays for columns output
 */
const getItemValueColumns = (items) => {
	var titles = items.map(a => a.title);
	var mid = Math.ceil(titles.length/2),
	obj = {
		left: titles.slice(0, mid),
		right: titles.slice(mid)
	}
	return obj;
}



const blockElements = {
    animator: 'accordion-animator',
    content: 'accordion-content',
    panel: 'accordion-panel',
    label: 'accordion-title'
}


const helpTips = {
	name: "Not required, if you don't want to show your name on the passport. You can also use a nickname",
	pronouns: "The pronouns you wish to be known by",
	age: "Your Age, e.g. '16'",
	gender: "You can write any gender that describes you. Also accepts 'unsure' if you're not sure.",
	contact_no: "The best way to contact you",
	emergency_name: "Who should be contacted in an emergency? It might help to put in their relationship to you e.g. 'Aunty - Jane Smith'",
	emergency_number: "The phone number of your emergency contact",
	no_contact: "A person who you do NOT want to be contacted, e.g. 'Dad - John Smith'",
	background: "This is for you to write your own story, it can be written however you like, and can include anything you want it to",
	myhealth: "This can be mental or physical health. Things like conditions, allergies, diagnoses from professionals or your own diagnosis",
	medication_take: "Do you take medication? Use this space to write what you think about it",
	medication_taken: "This is a way to track any medication you have had in the past. Use this space to write what you thought about it and when you took it",
	services: "Here you can write any professionals you have spoken to about your mental health",
	help: "What things, people, activities can help with your mental wellbeing",
	doesnthelp: "What things, people, activities have you tried, but don’t help you",
	triggers: "Things that you find really difficult to talk about or to be around",
	tosay: "A space for anything else you’d like to write about. You can choose to share this with people when you want to",
	// age: "",
}

class PassportContainer extends React.Component {
	state = {
		fields: {
			name: '',
			pronouns: '',
			age: '',
			gender: '',
			contact_no: '',
			emergency_name: '',
			emergency_number: '',
			no_contact: '',
			background: '',
			myhealth: '',
			medication_take: '',
			medication_take_items: [], //{id: 1, title: "Something"}, {id: 2, title: "Something else"}],
			medication_taken: '',
			medication_taken_items: [],
			services: '',
			services_items: [],
			help: '',
			help_items: [],
			doesnthelp: '',
			doesnthelp_items: [],
			triggers: '',
			triggers_items: [],
			tosay: '',
		},
		fieldErrors: {
		}
	}


	handleSave = (e) => {
		e.preventDefault();
		// console.log("Save");

		const data = {
			name: this.state.fields.name,
			age: this.state.fields.age,
			pronouns: this.state.fields.pronouns,
			gender: this.state.fields.gender,
			contact_no: this.state.fields.contact_no,
			emergency_name: this.state.fields.emergency_name,
			emergency_number: this.state.fields.emergency_number,
			no_contact: this.state.fields.no_contact,
			background: this.state.fields.background,
			myhealth: this.state.fields.myhealth,
			// medication_take: '',
			medication_take_items: this.state.fields.medication_take_items,
			// medication_taken: '',
			medication_taken_items: this.state.fields.medication_taken_items,
			// services: '',
			services_items: this.state.fields.services_items,
			// help: '',
			help_items: this.state.fields.help_items,
			// doesnthelp: '',
			doesnthelp_items: this.state.fields.doesnthelp_items,
			// triggers: '',
			triggers_items: this.state.fields.triggers_items,
			tosay: this.state.fields.tosay,
		}

		// console.log(data);
		// console.log("Update");
		Client.put('/api/crm/passport', data, (ret) => {
			// console.log("Saved...");
			// console.log(ret);
			// this.updateAppointment(data);
		});
	}


	handlePrint = (e) => {
		e.preventDefault();

		const lastUpdated = moment().format("Do MMMM YYYY");
		const medicationTakeCols = getItemValueColumns(this.state.fields.medication_take_items);
		const medicationPastCols = getItemValueColumns(this.state.fields.medication_taken_items);
		const servicesCols = getItemValueColumns(this.state.fields.services_items);
		const helpCols = getItemValueColumns(this.state.fields.help_items);
		const doesnthelpCols = getItemValueColumns(this.state.fields.doesnthelp_items);
		const triggersCols = getItemValueColumns(this.state.fields.triggers_items);

		const {vfs} = vfsFonts.pdfMake;
		pdfMake.vfs = vfs;
		

		var docDefinition = {
			content: [
				{ text: 'My Mental Health Passport', style: 'h1', alignment: 'center' },
				{ text: 'Last updated on '  + lastUpdated, style: 'lastupdated', alignment: 'center' },

				{ table : { body: [[{ text: 'My Details', style: 'h2' }],['']], headerRows : 1, widths: ['*'] }, layout : 'headerLineOnly', marginBottom: 16 },

				{ columns: [
					{ text: [{ text: 'Pronouns ', bold: true }, this.state.fields.pronouns ], style: 'lineitem' }, 
					]
				},

				{ columns: [
					{ text: [{ text: 'Preferred Name ', bold: true }, this.state.fields.name ], style: 'lineitem' }, 
					{ text: [{ text: 'Contact Number ', bold: true }, this.state.fields.contact_no ], style: 'lineitem' }, 
					]
				},

				{ columns: [
					{ text: [{ text: 'Gender ', bold: true }, this.state.fields.gender ], style: 'lineitem' }, 
					{ text: [{ text: 'Age ', bold: true }, this.state.fields.age ], style: 'lineitem' }, 
					]
				},

				{ columns: [
					{ text: [{ text: 'Emergency Contact Name ', bold: true }, this.state.fields.emergency_name ], style: 'lineitem' }, 
					{ text: [{ text: 'Emergency Number ', bold: true }, this.state.fields.emergency_number ], style: 'lineitem' }, 
					]
				},


				{ table : { body: [[{ text: 'My Background / Story', style: 'h2' }],['']], headerRows : 1, widths: ['*'] }, layout : 'headerLineOnly', marginBottom: 16 },
				this.state.fields.background,

				{ table : { body: [[{ text: 'My Health, from My Perspective', style: 'h2' }],['']], headerRows : 1, widths: ['*'] }, layout : 'headerLineOnly', marginBottom: 16 },
				this.state.fields.myhealth,


				{ table : { body: [[{ text: 'My Health, from My Perspective', style: 'h2' }],['']], headerRows : 1, widths: ['*'] }, layout : 'headerLineOnly', marginBottom: 16 },
				{ text: [{ text: 'Medication I take ', bold: true }], style: 'lineitem', marginBottom: 10 }, 
				{
					alignment: 'left',
					columns: [
						{
							ul: medicationTakeCols.left						
						},
						{
							ul: medicationTakeCols.right
						},
					]
				},

				{ text: [{ text: "Medication I've taken in the past ", bold: true }], style: 'lineitem', marginTop: 15, marginBottom: 10 }, 
				{
					alignment: 'left',
					columns: [
						{
							ul: medicationPastCols.left						
						},
						{
							ul: medicationPastCols.right
						},
					]
				},

				{ table : { body: [[{ text: "Services I've Used", style: 'h2' }],['']], headerRows : 1, widths: ['*'] }, layout : 'headerLineOnly', marginBottom: 16 },
				{
					alignment: 'left',
					columns: [
						{
							ul: servicesCols.left						
						},
						{
							ul: servicesCols.right
						},
					]
				},


				{ table : { body: [[{ text: "How I Like to be Helped", style: 'h2' }],['']], headerRows : 1, widths: ['*'] }, layout : 'headerLineOnly', marginBottom: 16 },
				{
					alignment: 'left',
					columns: [
						{
							ul: helpCols.left						
						},
						{
							ul: helpCols.right
						},
					]
				},

				{ table : { body: [[{ text: "What Doesn't Help", style: 'h2' }],['']], headerRows : 1, widths: ['*'] }, layout : 'headerLineOnly', marginBottom: 16 },
				{
					alignment: 'left',
					columns: [
						{
							ul: doesnthelpCols.left						
						},
						{
							ul: doesnthelpCols.right
						},
					]
				},


				{ table : { body: [[{ text: "My Triggers", style: 'h2' }],['']], headerRows : 1, widths: ['*'] }, layout : 'headerLineOnly', marginBottom: 16 },
				{
					alignment: 'left',
					columns: [
						{
							ul: triggersCols.left						
						},
						{
							ul: triggersCols.right
						},
					]
				},

				{ table : { body: [[{ text: "I've Also Like to Say", style: 'h2' }],['']], headerRows : 1, widths: ['*'] }, layout : 'headerLineOnly', marginBottom: 16 },
				this.state.fields.tosay,
			],

			footer: {
				columns: [
					{ text: [{ text: 'Created by MyMHP  - ', bold: true }, 'www.mymhp.org.uk' ], style: 'footer', alignment: 'center' }, 

				]
			},


			styles: {
				h1: {
					fontSize: 18,
					bold: true,
					marginBottom: 6,
				},
				h2: {
					fontSize: 16,
					bold: true,
					marginTop: 15,
					marginBottom: 10,
					alignment: 'right',
					color: '#5E99A0',
				},
				lastupdated: {
					fontSize: 10,
					marginBottom: 20,
				},
				footer: {
					fontSize: 10,
					marginBottom: 20,
					color: '#bbb',
				},
				lineitem: {
					fontSize: 13,
					marginBottom: 6,
				},
				bigger: {
					fontSize: 15,
					italics: true
				},
				smaller: {
					fontSize: 10,
				}
			},
			defaultStyle: {
				columnGap: 20
			}
		}

		pdfMake.createPdf(docDefinition).download('MyMHP.pdf');

	}


	handleFieldChange = (e) => {
		const fields = this.state.fields;
		fields[e.target.name] = e.target.value;
		this.setState({ fields });
	};

	handleKey = (e) => {
	};


	addItem = (field) => {
		const title = this.state.fields[field];
		if (title !== '') {
			var fields = this.state.fields;
			fields[field] = '';

			const entry = { id: uuidv4(), title: title }
			fields[field + '_items'] = this.state.fields[field + '_items'].concat([entry]);
			this.setState({ fields });
		}
	};


	removeItem = (e, field, id) => {
		e.preventDefault();
		var fields = this.state.fields;
		var currentItems = this.state.fields[field + '_items'];

		var index = findIndex(id, currentItems, 'id');
		currentItems.splice(index, 1);
  		fields[field + '_items'] = currentItems;
		this.setState({ fields });
	};


	loadPassport = () => {
		Client.get('/api/crm/passport', (serverPassport) => {
			var fields = {
				name: serverPassport.name || '',
				pronouns: serverPassport.pronouns || '',
				age: serverPassport.age || '',
				gender: serverPassport.gender || '',
				contact_no: serverPassport.contact_no || '',
				emergency_name: serverPassport.emergency_name || '',
				emergency_number: serverPassport.emergency_number || '',
				no_contact: serverPassport.no_contact || '',
				background: serverPassport.background || '',
				myhealth: serverPassport.myhealth || '',
				medication_take: '',
				medication_take_items: serverPassport.medication_take_items || [],
				medication_taken: '',
				medication_taken_items: serverPassport.medication_taken_items || [],
				services: '',
				services_items: serverPassport.services_items || [],
				help: '',
				help_items: serverPassport.help_items || [],
				doesnthelp: '',
				doesnthelp_items: serverPassport.doesnthelp_items || [],
				triggers: '',
				triggers_items: serverPassport.triggers_items || [],
				tosay: serverPassport.tosay || '',
			}
			this.setState({ fields })
		});
	};




	componentDidMount() {
		this.loadPassport();
	}


	render() {
		const medication_take_items = this.state.fields.medication_take_items.map((item) => (
			<li key={item.id} className="d-flex justify-content-between">
				<span>{item.title}</span>
				<a href="#" onClick={(e)=>this.removeItem(e, 'medication_take', item.id)} className="close"><i className="fa fa-close"></i></a>
			</li>
		));

		const medication_taken_items = this.state.fields.medication_taken_items.map((item) => (
			<li key={item.id} className="d-flex justify-content-between">
				<span>{item.title}</span>
				<a href="#" onClick={(e)=>this.removeItem(e, 'medication_taken', item.id)} className="close"><i className="fa fa-close"></i></a>
			</li>
		));

		const services_items = this.state.fields.services_items.map((item) => (
			<li key={item.id} className="d-flex justify-content-between">
				<span>{item.title}</span>
				<a href="#" onClick={(e)=>this.removeItem(e, 'services', item.id)} className="close"><i className="fa fa-close"></i></a>
			</li>
		));

		const help_items = this.state.fields.help_items.map((item) => (
			<li key={item.id} className="d-flex justify-content-between">
				<span>{item.title}</span>
				<a href="#" onClick={(e)=>this.removeItem(e, 'help', item.id)} className="close"><i className="fa fa-close"></i></a>
			</li>
		));


		const doesnthelp_items = this.state.fields.doesnthelp_items.map((item) => (
			<li key={item.id} className="d-flex justify-content-between">
				<span>{item.title}</span>
				<a href="#" onClick={(e)=>this.removeItem(e, 'doesnthelp', item.id)} className="close"><i className="fa fa-close"></i></a>
			</li>
		));

		const triggers_items = this.state.fields.triggers_items.map((item) => (
			<li key={item.id} className="d-flex justify-content-between">
				<span>{item.title}</span>
				<a href="#" onClick={(e)=>this.removeItem(e, 'triggers', item.id)} className="close"><i className="fa fa-close"></i></a>
			</li>
		));





		return (
			<div className="container">

				<div className="card">
					<div className="card-block">

						<div className="dropdown pull-right">
							<a className="btn btn-primary" href="#" onClick={(e)=>this.handleSave(e)}><i className="fa fa-save"></i> Save Passport</a>
						</div>

						<h4 style={{marginBottom: 30 + "px"}}><i className="fa fa-address-card"></i> My Passport</h4>

						<Tabbordion blockElements={blockElements} className="accordion" name="tabs" mode="single" animateContent='height'>
							<TabPanel className="passport-accordion">
								<TabLabel><i className="fa fa-fw fa-user-o"></i> My Details</TabLabel>
								<TabContent>
									<div className="row">
										<div className="col-md-12">
											<div className="form-group row">
												<div className="col-sm-3">
													<label htmlFor="inputName" className="col-form-label">Preferred Name</label>
													<Tooltip html={(<span>{helpTips.name}</span>)} position="top" trigger="mouseenter" arrow={true}><i className="accordion-icon fa fa-info-circle"></i></Tooltip>
													<input type="text" name="name" className="form-control" id="inputName" placeholder="" value={this.state.fields.name} onChange={this.handleFieldChange}/>
													<span className="formError">{ this.state.fieldErrors.name }</span>
												</div>
												<div className="col-sm-2">
													<label htmlFor="inputPronouns" className="col-form-label">Pronouns</label>
													<Tooltip html={(<span>{helpTips.pronouns}</span>)} position="top" trigger="mouseenter" arrow={true}><i className="accordion-icon fa fa-info-circle"></i></Tooltip>
													<input type="text" name="pronouns" className="form-control" id="inputPronouns" placeholder="" value={this.state.fields.pronouns} onChange={this.handleFieldChange}/>
													<span className="formError">{ this.state.fieldErrors.pronouns }</span>
												</div>
												<div className="col-sm-2">
													<label htmlFor="inputAge" className="col-form-label">Age</label>
													<Tooltip html={(<span>{helpTips.age}</span>)} position="top" trigger="mouseenter" arrow={true}><i className="accordion-icon fa fa-info-circle"></i></Tooltip>
													<input type="text" name="age" className="form-control" id="inputAge" placeholder="" value={this.state.fields.age} onChange={this.handleFieldChange}/>
													<span className="formError">{ this.state.fieldErrors.age }</span>
												</div>
												<div className="col-sm-2">
													<label htmlFor="inputGender" className="col-form-label">Gender</label>
													<Tooltip html={(<span>{helpTips.gender}</span>)} position="top" trigger="mouseenter" arrow={true}><i className="accordion-icon fa fa-info-circle"></i></Tooltip>
													<input type="text" name="gender" className="form-control" id="inputGender" placeholder="" value={this.state.fields.gender} onChange={this.handleFieldChange}/>
													<span className="formError">{ this.state.fieldErrors.gender }</span>
												</div>
												<div className="col-sm-3">
													<label htmlFor="inputContactNo" className="col-form-label">Contact Number</label>
													<Tooltip html={(<span>{helpTips.contact_no}</span>)} position="top" trigger="mouseenter" arrow={true}><i className="accordion-icon fa fa-info-circle"></i></Tooltip>
													<input type="text" name="contact_no" className="form-control" id="inputContactNo" placeholder="" value={this.state.fields.contact_no} onChange={this.handleFieldChange}/>
													<span className="formError">{ this.state.fieldErrors.contact_no }</span>
												</div>
											</div>
										</div>
									</div>

									<div className="row">
										<div className="col-md-12">
											<div className="form-group row">
												<div className="col-sm-4">
													<label htmlFor="inputEmergencyName" className="col-form-label">Emergency Contact Name</label>
													<Tooltip html={(<span>{helpTips.emergency_name}</span>)} position="top" trigger="mouseenter" arrow={true}><i className="accordion-icon fa fa-info-circle"></i></Tooltip>
													<input type="text" name="emergency_name" className="form-control" id="inputEmergencyName" placeholder="" value={this.state.fields.emergency_name} onChange={this.handleFieldChange}/>
													<span className="formError">{ this.state.fieldErrors.emergency_name }</span>
												</div>
												<div className="col-sm-4">
													<label htmlFor="inputEmergencyNumber" className="col-form-label">Emergency Contact Number</label>
													<Tooltip html={(<span>{helpTips.emergency_number}</span>)} position="top" trigger="mouseenter" arrow={true}><i className="accordion-icon fa fa-info-circle"></i></Tooltip>
													<input type="text" name="emergency_number" className="form-control" id="inputEmergencyNumber" placeholder="" value={this.state.fields.emergency_number} onChange={this.handleFieldChange}/>
													<span className="formError">{ this.state.fieldErrors.emergency_number }</span>
												</div>
												<div className="col-sm-4">
													<label htmlFor="inputNoContact" className="col-form-label">Do <strong>Not</strong> Contact</label>
													<Tooltip html={(<span>{helpTips.no_contact}</span>)} position="top" trigger="mouseenter" arrow={true}><i className="accordion-icon fa fa-info-circle"></i></Tooltip>
													<input type="text" name="no_contact" className="form-control" id="inputNoContact" placeholder="" value={this.state.fields.no_contact} onChange={this.handleFieldChange}/>
													<span className="formError">{ this.state.fieldErrors.no_contact }</span>
												</div>
											</div>
										</div>
									</div>
								</TabContent>
							</TabPanel>

							<TabPanel>
								<TabLabel><i className="fa fa-fw fa-heartbeat"></i> My Background / My Health</TabLabel>
								<TabContent>
									<div className="row">
										<div className="col-md-12">
											<div className="form-group row">
												<div className="col-sm-6">
													<label htmlFor="inputBackground" className="col-form-label">My Background / Story</label>
													<Tooltip html={(<span>{helpTips.background}</span>)} position="top" trigger="mouseenter" arrow={true}><i className="accordion-icon fa fa-info-circle"></i></Tooltip>
													<textarea name="background" className="form-control" id="inputBackground" placeholder="" value={this.state.fields.background} style={{minHeight: '180px'}} onChange={this.handleFieldChange}/>
													<span className="formError">{ this.state.fieldErrors.background }</span>
												</div>
												<div className="col-sm-6">
													<label htmlFor="inputMyHealth" className="col-form-label">My Health, From My Perspective</label>
													<Tooltip html={(<span>{helpTips.myhealth}</span>)} position="top" trigger="mouseenter" arrow={true}><i className="accordion-icon fa fa-info-circle"></i></Tooltip>
													<textarea name="myhealth" className="form-control" id="inputMyHealth" placeholder="" value={this.state.fields.myhealth} style={{minHeight: '180px'}} onChange={this.handleFieldChange}/>
													<span className="formError">{ this.state.fieldErrors.myhealth }</span>
												</div>
											</div>
										</div>
									</div>
								</TabContent>
							</TabPanel>

							<TabPanel>
								<TabLabel><i className="fa fa-fw fa-medkit"></i> Medication</TabLabel>
								<TabContent>
									<div className="row">
										<div className="col-md-12">
											<p className="text-muted">When you have typed in the box, click on the + to add a new box. Don’t worry about spellings!</p>

											<div className="form-group row">
												<div className="col-sm-6">
													<label htmlFor="inputMedicationTake" className="col-form-label">Medication I take</label>
													<Tooltip html={(<span>{helpTips.medication_take}</span>)} position="top" trigger="mouseenter" arrow={true}><i className="accordion-icon fa fa-info-circle"></i></Tooltip>

														{ medication_take_items && 
															<ul className="listitem">{medication_take_items}</ul>
														}

														<div className="input-group">
															<input name="medication_take" value={this.state.fields.medication_take} onChange={this.handleFieldChange} onKeyPress={this.handleKey} type="text" className="form-control" placeholder="e.g. sertraline/anti-depressant, started in 2017, it’s ok"/>
															<span className="input-group-btn">
																<button className="btn btn-primary" type="button" onClick={(e)=>this.addItem('medication_take')}><i className="fa fa-plus" style={{ fontSize: 18, paddingTop: 4 }}></i></button>
															</span>
														</div>

													<span className="formError">{ this.state.fieldErrors.medication_take }</span>
												</div>
												<div className="col-sm-6">
													<label htmlFor="inputMedicationTaken" className="col-form-label">Medication I've taken in the past</label>
													<Tooltip html={(<span>{helpTips.medication_taken}</span>)} position="top" trigger="mouseenter" arrow={true}><i className="accordion-icon fa fa-info-circle"></i></Tooltip>

														{ medication_taken_items && 
															<ul className="listitem">{medication_taken_items}</ul>
														}

														<div className="input-group">
															<input name="medication_taken" value={this.state.fields.medication_taken} onChange={this.handleFieldChange} type="text" className="form-control" placeholder="e.g. propranolol/anti-anxiety, finished in 2017, got skin rash"/>
															<span className="input-group-btn">
																<button className="btn btn-primary" type="button" onClick={(e)=>this.addItem('medication_taken')}><i className="fa fa-plus" style={{ fontSize: 18, paddingTop: 4 }}></i></button>
															</span>
														</div>


													<span className="formError">{ this.state.fieldErrors.medication_taken }</span>
												</div>
											</div>
										</div>
									</div>
								</TabContent>
							</TabPanel>

							<TabPanel>
								<TabLabel><i className="fa fa-fw fa-life-ring"></i> Services Used / How I Like to be Helped</TabLabel>
								<TabContent>
									<div className="row">
										<div className="col-md-12">
											<p className="text-muted">When you have typed in the box, click on the + to add a new box. Don’t worry about spellings!</p>

											<div className="form-group row">
												<div className="col-sm-6">
													<label htmlFor="inputBackground" className="col-form-label">Services I've Used</label>
													<Tooltip html={(<span>{helpTips.services}</span>)} position="top" trigger="mouseenter" arrow={true}><i className="accordion-icon fa fa-info-circle"></i></Tooltip>

														{ services_items && 
															<ul className="listitem">{services_items}</ul>
														}

														<div className="input-group">
															<input name="services" value={this.state.fields.services} onChange={this.handleFieldChange} type="text" className="form-control" placeholder="e.g CAMHS, School, GP etc."/>
															<span className="input-group-btn">
																<button className="btn btn-primary" type="button" onClick={(e)=>this.addItem('services')}><i className="fa fa-plus" style={{ fontSize: 18, paddingTop: 4 }}></i></button>
															</span>
														</div>

													<span className="formError">{ this.state.fieldErrors.services }</span>
												</div>
												<div className="col-sm-6">
													<label htmlFor="inputHelp" className="col-form-label">How I Like to be Helped</label>
													<Tooltip html={(<span>{helpTips.help}</span>)} position="top" trigger="mouseenter" arrow={true}><i className="accordion-icon fa fa-info-circle"></i></Tooltip>

														{ help_items && 
															<ul className="listitem">{help_items}</ul>
														}

														<div className="input-group">
															<input name="help" value={this.state.fields.help} onChange={this.handleFieldChange} type="text" className="form-control" placeholder=""/>
															<span className="input-group-btn">
																<button className="btn btn-primary" type="button" onClick={(e)=>this.addItem('help')}><i className="fa fa-plus" style={{ fontSize: 18, paddingTop: 4 }}></i></button>
															</span>
														</div>


													<span className="formError">{ this.state.fieldErrors.help }</span>
												</div>
											</div>
										</div>
									</div>
								</TabContent>
							</TabPanel>

							<TabPanel>
								<TabLabel><i className="fa fa-fw fa-frown-o"></i> What Doesn't Help / My Triggers</TabLabel>
								<TabContent>
									<div className="row">
										<div className="col-md-12">
											<p className="text-muted">When you have typed in the box, click on the + to add a new box. Don’t worry about spellings!</p>

											<div className="form-group row">
												<div className="col-sm-6">
													<label htmlFor="inputDoesntHelp" className="col-form-label">What Doesn't Help</label>
													<Tooltip html={(<span>{helpTips.doesnthelp}</span>)} position="top" trigger="mouseenter" arrow={true}><i className="accordion-icon fa fa-info-circle"></i></Tooltip>

														{ doesnthelp_items && 
															<ul className="listitem">{doesnthelp_items}</ul>
														}

														<div className="input-group">
															<input name="doesnthelp" value={this.state.fields.doesnthelp} onChange={this.handleFieldChange} type="text" className="form-control" placeholder=""/>
															<span className="input-group-btn">
																<button className="btn btn-primary" type="button" onClick={(e)=>this.addItem('doesnthelp')}><i className="fa fa-plus" style={{ fontSize: 18, paddingTop: 4 }}></i></button>
															</span>
														</div>

													<span className="formError">{ this.state.fieldErrors.doesnthelp }</span>
												</div>
												<div className="col-sm-6">
													<label htmlFor="inputTriggers" className="col-form-label">My Triggers</label>
													<Tooltip html={(<span>{helpTips.triggers}</span>)} position="top" trigger="mouseenter" arrow={true}><i className="accordion-icon fa fa-info-circle"></i></Tooltip>

														{ triggers_items && 
															<ul className="listitem">{triggers_items}</ul>
														}

														<div className="input-group">
															<input name="triggers" value={this.state.fields.triggers} onChange={this.handleFieldChange} type="text" className="form-control" placeholder=""/>
															<span className="input-group-btn">
																<button className="btn btn-primary" type="button" onClick={(e)=>this.addItem('triggers')}><i className="fa fa-plus" style={{ fontSize: 18, paddingTop: 4 }}></i></button>
															</span>
														</div>


													<span className="formError">{ this.state.fieldErrors.triggers }</span>
												</div>
											</div>
										</div>
									</div>
								</TabContent>
							</TabPanel>

							<TabPanel>
								<TabLabel><i className="fa fa-fw fa-sticky-note-o"></i> I'd Also Like to Say...</TabLabel>
								<TabContent>
									<div className="row">
										<div className="col-md-12">
											<div className="form-group row">
												<div className="col-sm-12">
													<label htmlFor="inputToSay" className="col-form-label">I'd Also Like to Say...</label>
													<Tooltip html={(<span>{helpTips.tosay}</span>)} position="top" trigger="mouseenter" arrow={true}><i className="accordion-icon fa fa-info-circle"></i></Tooltip>
													<textarea name="tosay" className="form-control" id="inputToSay" placeholder="" value={this.state.fields.tosay} style={{minHeight: '180px'}} onChange={this.handleFieldChange}/>

													<span className="formError">{ this.state.fieldErrors.tosay }</span>
												</div>
											</div>
										</div>
									</div>
								</TabContent>
							</TabPanel>


						</Tabbordion>


						<hr/>
						<div className="pull-right">
							<a className="btn btn-primary" href="#" onClick={(e)=>this.handleSave(e)}><i className="fa fa-save"></i> Save Passport</a>
						</div>

						<div className="text-center mt-5" style={{clear: `both`}}>
							<a className="btn btn-secondary" href="#" onClick={(e)=>this.handlePrint(e)}><i className="fa fa-print"></i> Create PDF/Print</a>
						</div>

					</div>
				</div>

			</div>



		);
	}
}




export default PassportContainer;




// WEBPACK FOOTER //
// ./src/js/components/containers/PassportContainer.js